import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import {useIntl} from 'react-intl';
import {Button, makeStyles} from '@material-ui/core';
import {ExpandMore, Language} from '@material-ui/icons';
import useMenu from './hooks/useMenu';
import useLocale from './locale/useLocale';
import getName from './locale/getName';

const useStyles = makeStyles((theme) => ({
  text: {
    margin: theme.spacing(0, 0.5),
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
}));

export default function LocaleSwitcher({languages}) {
  const classes = useStyles();
  const intl = useIntl();
  const [locale, setLocale] = useLocale();
  //get organization languages from context
  const {anchorEl, isOpen, menuId, handleOpen, handleClose} = useMenu('locale-switcher');

  return (
    languages?.length > 1 ?
      <>
        <Button
          aria-label={intl.formatMessage({defaultMessage: 'kielivalikko'})}
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={handleOpen}
          color="inherit">
          <Language/>
          <span className={classes.text}>{getName(locale)}</span>
          <ExpandMore fontSize="small"/>
        </Button>
        <Menu
          id={menuId}
          anchorEl={anchorEl}
          anchorOrigin={{vertical: 'top', horizontal: 'right',}}
          keepMounted
          transformOrigin={{vertical: 'top', horizontal: 'right',}}
          open={isOpen}
          onClose={handleClose}>
          {languages.map((localeValue) => (
            <MenuItem
              key={localeValue}
              selected={locale === localeValue}
              onClick={() => {
                setLocale(localeValue);
                handleClose();
              }}>
              {getName(localeValue)}
            </MenuItem>
          ))}
        </Menu>
      </> : <div/>
  );
}
